// Content.js

import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom'

import Dashboard from './Dashboard.js'
import InvertersTable from './InvertersTable.js'
import Inverter from './Inverter.js'
import ProfileDetails from './ProfileDetails.js'
import Settings from './Settings.js'
import EnergyDetails from './EnergyDetails.js';
import Members from './Members.js';
import CombinerBoxes from './CombinerBoxes.js';
import Alarm from './Alarm.js';

export default class Content extends Component {
    render() {
        return (
            <Switch>
                <Route path="/members" render={(props) => <Members {...props} user={this.props.user}/>}/>
                <Route path="/inverter" render={(props) => <Inverter {...props} user={this.props.user}/>}/>
                <Route path="/combinerboxes" render={(props) => <CombinerBoxes {...props} user={this.props.user}/>}/>

                <Route path="/inverters" render={(props) => <InvertersTable {...props} user={this.props.user}/>}/>
                <Route path="/dashboard" render={(props) => <Dashboard {...props} user={this.props.user} handleUpdateStation={this.props.handleUpdateStation}/>}/>
                <Route path="/profile" render={(props) => <ProfileDetails {...props} user={this.props.user} updateUserProfile={this.props.updateUserProfile}/>}/>
                <Route path="/settings" render={(props) => <Settings {...props} user={this.props.user} handleUpdateStation={this.props.handleUpdateStation}/>}/>
                <Route path="/alarms" render={(props) => <Alarm {...props} user={this.props.user} handleUpdateStation={this.props.handleUpdateStation}/>}/>
                <Route path="/energy-details" render={(props) => <EnergyDetails {...props} user={this.props.user}/>}/>
                <Route path="/" render={(props) => <Dashboard {...props} user={this.props.user}/>}/>
            </Switch>
        )
    }
}